import {ServiceBase} from "../ServiceBase";
import { IControlCenterService } from "./control-center.service.interface";
export class ControlCenterService extends ServiceBase implements IControlCenterService {
  get isEnabled(): boolean {
    if(this.services.user.isAuthorized) {
      return this.services.abTestingFeatureDataProvider.enableControlCenter;
    } else {
      return false;
    }
  }
}